/**
 * Human-readable message for wallet / RPC / contract errors (for error toasts).
 * Maps user rejection to a short line instead of raw provider strings.
 * @param {unknown} err
 * @returns {string}
 */
export function formatTxError(err) {
  if (err == null) return "Something went wrong.";

  if (typeof err === "object") {
    const e = /** @type {Record<string, unknown> & { cause?: unknown }} */ (
      err
    );
    const code = e.code;
    if (code === 4001 || code === "ACTION_REJECTED") {
      return "Transaction rejected.";
    }
    const name = String(e.name ?? "");
    if (name === "UserRejectedRequestError") {
      return "Transaction rejected.";
    }
    const short = e.shortMessage;
    if (typeof short === "string" && short.length > 0) {
      if (isUserRejectionMessage(short)) return "Transaction rejected.";
      return short;
    }
    const msg = String(e.message ?? "");
    if (isUserRejectionMessage(msg)) return "Transaction rejected.";
    if (msg.length > 0) return msg;

    if (e.cause) return formatTxError(e.cause);
  }

  const s = String(err);
  if (isUserRejectionMessage(s)) return "Transaction rejected.";
  return s || "Something went wrong.";
}

/**
 * @param {string} s
 */
function isUserRejectionMessage(s) {
  const t = s.toLowerCase();
  return (
    t.includes("user rejected") ||
    t.includes("rejected the request") ||
    t.includes("user denied") ||
    t.includes("denied transaction") ||
    t.includes("request rejected") ||
    (t.includes("rejected") && t.includes("transaction"))
  );
}
